import Vue from 'vue';


Vue.filter('formatDate', function (datetime) {
    let monthNames = [
            "Jan", "Feb", "Mar",
            "Apr", "May", "June", "July",
            "Aug", "Sep", "Oct",
            "Nov", "Dec"
        ],
        outputDate = new Date(datetime),
        hours = outputDate.getHours(),
        ampm = 'am',
        minutes;

    if (hours > 12) {
        ampm = 'pm';
        hours -= 12;
    }

    if (hours === 0) {
        hours = 12;
    }

    minutes = (outputDate.getMinutes() < 10 ? '0' : '') + outputDate.getMinutes();

    return hours + ':' + minutes + ampm + ', ' + monthNames[outputDate.getMonth()] +
        " " + outputDate.getDate();
});

Vue.filter('formatDateWithoutTime', function (datetime) {
    let monthNames = [
            "Jan", "Feb", "Mar",
            "Apr", "May", "June", "July",
            "Aug", "Sep", "Oct",
            "Nov", "Dec"
        ],
        outputDate = new Date(datetime);

    return monthNames[outputDate.getMonth()] +
        " " + outputDate.getDate() + ", " + outputDate.getFullYear();
});

Vue.filter('formatDateWithJustTime', function (datetime) {
    let outputDate = new Date(datetime),
        hours = outputDate.getHours(),
        ampm = 'am',
        minutes;

    if (hours >= 12) {
        ampm = 'pm';
        hours -= 12;
    }

    if (hours === 0) {
        hours = 12;
    }

    minutes = (outputDate.getMinutes() < 10 ? '0' : '') + outputDate.getMinutes();

    return hours + ':' + minutes + ampm;
});

Vue.filter('formatDateCondensed', function (datetime) {
    let outputDate = new Date(datetime),
        hours = outputDate.getHours(),
        ampm = 'am',
        minutes;


    if (hours >= 12) {
        ampm = 'pm';
        hours -= 12;
    }

    if (hours === 0) {
        hours = 12;
    }

    minutes = (outputDate.getMinutes() < 10 ? '0' : '') + outputDate.getMinutes();

    return (outputDate.getMonth() + 1) + '.' + outputDate.getDate() + "." + outputDate.getFullYear() +
        ' | ' + hours + ':' + minutes + ampm;
});

Vue.filter('joinArray', function (input, subArr) {
    let output;
    let subArrCombined = [];

    if (subArr) {
        input.forEach(function (item) {
            subArrCombined.push(item[subArr])
        });
        output = subArrCombined.join(', ')
    } else {
        output = input.join(', ');
    }

    return output;
});

Vue.filter('markdown', function (content) {
    let markdownTargetBlank = require('./ForkedModules/markdown-it-target-blank');

    let md = require('markdown-it')({
        html: false,
        linkify: true,
        breaks: false,
        typographer: true,
    })
        .use(markdownTargetBlank);

    md.disable(['heading', 'fence', 'blockquote', 'code', 'hr', 'html_block', 'lheading', 'list', 'reference']);

    content = md.render(content);

    return (content);
});

Vue.filter('capitalizeFirstLetter', function (content) {
    return content.charAt(0).toUpperCase() + content.slice(1);
});


// WEBPACK FOOTER //
// ./src/vueFilters.js